import { ReactElement } from 'react';
import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import BmsmChart from '~/ui/components/common/Banner/BmsmChart';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';

interface IProps {
  promotion: IGetPromotionResponse;
}

// TODO translations

const HeroSection = ({ promotion }: IProps): ReactElement => {
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tHero } = useTranslation('', { keyPrefix: '$pages.$home.$hero' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$hero' });

  const domain = process.env.NEXT_PUBLIC_SITE_URL;
  const isDevelopment =
    process.env.NODE_ENV === 'development' ||
    domain?.includes('localhost') ||
    domain?.includes('dev-eu') ||
    domain?.includes('staging-eu');

  const promoEnd = promotion?.promo_end;

  const endDay = promoEnd
    ? new Date(promoEnd).toLocaleDateString('en-US', { weekday: 'long' })
    : '';

  const countdownIsActive = promotion?.promo_days_left <= 3;

  return (
    <section className="hero-container" id="HP_hero_bed">
      <Link href={tLink('bed')}>
        {/* TODO: create a component for normal hero / bmsm hero? AFTER BMSM PROMO LAUNCHS */}
        {promotion?.promo_is_active && promotion?.promo_type === 'bmsm' ? (
          <>
            <div className="bmsm-hero-wrapper">
              <div className="hero-img-wrap">
                <picture>
                  <source srcSet="/images/misc/fill.gif" media="(max-width: 960px)" />
                  <img
                    className="hero-img"
                    src="/images/homePage/the-westin-heavenly-bed-sleep-well.webp"
                    alt={tHero('title')}
                    height={744}
                    width={1920}
                    loading="eager"
                    fetchPriority="high"
                  />
                </picture>
                <picture>
                  <source srcSet="/images/misc/fill.gif" media="(min-width: 961px)" />
                  <img
                    className="hero-img-mobile"
                    src="/images/homePage/the-westin-heavenly-bed-sleep-well-mobile.webp"
                    alt={tHero('title')}
                    height={848}
                    width={1300}
                    loading="eager"
                    fetchPriority="high"
                  />
                </picture>
              </div>
              <BmsmChart
                promotion={promotion}
                daysLeft={countdownIsActive ? promotion.promo_days_left : null}
                ends={endDay}
              />
            </div>
            {isDevelopment &&
              [2, 1, 0].map(i => (
                <div className="bmsm-hero-wrapper" key={i}>
                  <div className="hero-img-wrap">
                    <picture>
                      <source srcSet="/images/misc/fill.gif" media="(max-width: 960px)" />
                      <img
                        className="hero-img"
                        src="/images/homePage/the-westin-heavenly-bed-sleep-well.webp"
                        alt={tHero('title')}
                        height={744}
                        width={1920}
                        loading="eager"
                        fetchPriority="high"
                      />
                    </picture>
                    <picture>
                      <source srcSet="/images/misc/fill.gif" media="(min-width: 961px)" />
                      <img
                        className="hero-img-mobile"
                        src="/images/homePage/the-westin-heavenly-bed-sleep-well-mobile.webp"
                        alt={tHero('title')}
                        height={848}
                        width={1300}
                        loading="eager"
                        fetchPriority="high"
                      />
                    </picture>
                  </div>
                  <BmsmChart promotion={promotion} daysLeft={i} ends={endDay} />
                </div>
              ))}
          </>
        ) : (
          <div className="hero-img-wrap">
            <picture>
              <source srcSet="/images/misc/fill.gif" media="(max-width: 960px)" />
              <img
                className="hero-img"
                src="/images/homePage/the-westin-heavenly-bed-sleep-well.webp"
                alt={tHero('title')}
                height={744}
                width={1920}
                loading="eager"
                fetchPriority="high"
              />
            </picture>
            <picture>
              <source srcSet="/images/misc/fill.gif" media="(min-width: 961px)" />
              <img
                className="hero-img-mobile"
                src="/images/homePage/the-westin-heavenly-bed-sleep-well-mobile.webp"
                alt={tHero('title')}
                height={848}
                width={1300}
                loading="eager"
                fetchPriority="high"
              />
            </picture>
            <div className="hero-column">
              <div className="hero-stack">
                <h1 aria-label={tHero('title')}>
                  <span className="sr-only">{tHero('title')}</span>
                  <span className="hero-icon icon-heavenly-bed" />
                </h1>
                <p className="hero-text">{tHero('description')}</p>
                {/* TODO change ariaLabel value */}
                <Button ariaLabel={tButton('shopNow')} className="hero-btn">
                  {tButton('shopNow')}
                </Button>
              </div>
            </div>
          </div>
        )}
      </Link>
    </section>
  );
};

export default HeroSection;
